module.exports = __webpack_public_path__ + "img/publication-3.fdb85f43.svg";